<template>
  <div>
    <div v-if="open" class="modal-backdrop show" @click="hide"></div>
    <div class="flyout-panel" :class="{ 'flyout-panel--open': open }">
      <div class="flyout-panel__header">
        <div class="flyout-panel__title">{{ title }}</div>
        <i class="flyout-panel__icon fas fa-times-circle" @click="hide"></i>
      </div>
      <div class="flyout-panel__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps({
  title: {
    type: String,
    required: true
  }
});

const open = ref(false);

function show() {
  open.value = true;
}

function hide() {
  open.value = false;
}

defineExpose({ show, hide });
</script>

<style lang="scss" scoped>
.flyout-panel {
  position: fixed;
  width: 75%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  background: #fff;
  box-shadow: var(--box-shadow);
  z-index: 1100;
  transform: translateX(100%);
  transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  padding: 16px;
  overflow: auto;

  &--open {
    transform: translateX(0%);
  }

  &__header {
    display: flex;
    align-items: center;
    font-size: 21px;
    font-weight: 700;
  }
  &__icon {
    margin-left: auto;
    color: var(--primary-color);
  }
  &__content {
    margin-top: 10px;
  }
}
</style>
